"use client"
import React, { useState, useRef, useContext, LayoutContext } from 'react';
import { Chip } from 'primereact/chip';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import BlockViewer from '../BlockViewer';

//import Link from 'next/link';

import { StyleClass } from 'primereact/styleclass';
import { Button } from 'primereact/button';
import { Ripple } from 'primereact/ripple';
import { Divider } from 'primereact/divider';
import { Toast } from 'primereact/toast';
import { Panel } from 'primereact/panel';
import { Dialog } from 'primereact/dialog';
import { Avatar } from 'primereact/avatar';
import { ScrollPanel } from 'primereact/scrollpanel';
import { DeferredContent } from 'primereact/deferredcontent';
import { OverlayPanel } from 'primereact/overlaypanel';

//import { LayoutContext } from '../../../layout/context/layoutcontext';
//import { NodeRef } from '@/types';
import { classNames } from 'primereact/utils';
import FormularioCalculadoraCredito from '../components/DataTableGenerica/FormularioCalculadoraCredito';


import AuthStorage from '../storage/AuthStorage';
import AuthController from '../controller/AuthController';

import { GenericaSistemaService } from '../service/GenericaSistemaService';

import { BlocksGuestLandingRestablecimientoClave } from './BlocksGuestLandingRestablecimientoClave';


import "../assets/css/BlocksGuestLandingPageCredito.css";
import Formulario from './DataTableGenerica/Formulario';

const BlocksGuestLandingPageCredito = (props) => {
    const [isHidden, setIsHidden] = useState(false);
    //const { layoutConfig } = useContext(LayoutContext);
    const menuRef = useRef(null);

    const btInicioSesion = useRef(null);
    const op = useRef(null);

    const labelErrorRef = useRef(null);
    const [textoError, setTextoError] = useState("");

    const [intentoErrado, setIntentoErrado] = useState(0);
    const [vecesBotonPresionado, setVecesBotonPresionado] = useState(0);

    const modExternal = "CREDITO";

    const authController = new AuthController();
    const authStorage = new AuthStorage(window.location.pathname);
    const userDetails = authStorage.GetCurrentUser();

    const genericaSistemaService = new GenericaSistemaService();

    let dataConfigSubdomain = authStorage.getConfigSubdomain();

    let { subdomain, idSuscripcion, idEmpresaInit, idiomaInit, urlLogoLogin } = dataConfigSubdomain;

    const { userName, idEmpresa, idioma } = userDetails;

    const [selectedTipoGenericaFormularioFactura, setSelectedTipoGenericaFormularioFactura] = useState(undefined);
    const [metadataGenericaFormularioFactura, setMetadataGenericaFormularioFactura] = useState([]);
    const [genericaFormularioFactura, setGenericaFormularioFactura] = useState(undefined);
    const [genericaSistemaDialogFormularioFactura, setGenericaSistemaDialogFormularioFactura] = useState(false);
    const [genericaSistemaDialogFormulario, setGenericaSistemaDialogFormulario] = useState(false);



    // Para autorregistro

    const [selectedTipoGenericaFormularioFacturaAutoregistro, setSelectedTipoGenericaFormularioFacturaAutoregistro] = useState(undefined);
    const [metadataGenericaFormularioFacturaAutoregistro, setMetadataGenericaFormularioFacturaAutoregistro] = useState([]);
    const [genericaFormularioFacturaAutoregistro, setGenericaFormularioFacturaAutoregistro] = useState(undefined);
    const [genericaSistemaDialogFormularioFacturaAutoregistro, setGenericaSistemaDialogFormularioFacturaAutoregistro] = useState(false);
    const [genericaSistemaDialogFormularioAutoregistro, setGenericaSistemaDialogFormularioAutoregistro] = useState(false);


    let emptyGenericaSistemaInitAutorregistro = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", tg: "BAS_VSTA_TERCERO_INVITADO_INTENTO_AUTOREGISTRO", uts: { "ambito": "CREDITO" }
    };

    let selectedTipoGenericaFormularioAutoregistro = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", tg: "BAS_VSTA_TERCERO_INVITADO_INTENTO_AUTOREGISTRO"
    };

    let selectedTipoGenericaFormularioAutoregistroConfirmacionOpt = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", tg: "BAS_VSTA_TERCERO_INVITADO_INTENTO_AUTOREGISTRO_CONFIRMACION_OPT"
    };

    // Para restablecimiento 

    const [selectedTipoGenericaFormularioFacturaRestablecimiento, setSelectedTipoGenericaFormularioFacturaRestablecimiento] = useState(undefined);
    const [metadataGenericaFormularioFacturaRestablecimiento, setMetadataGenericaFormularioFacturaRestablecimiento] = useState([]);
    const [genericaFormularioFacturaRestablecimiento, setGenericaFormularioFacturaRestablecimiento] = useState(undefined);
    const [genericaSistemaDialogFormularioFacturaRestablecimiento, setGenericaSistemaDialogFormularioFacturaRestablecimiento] = useState(false);
    const [genericaSistemaDialogFormularioRestablecimiento, setGenericaSistemaDialogFormularioRestablecimiento] = useState(false);


    let emptyGenericaSistemaInitRestablecimiento = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", tg: "BAS_VSTA_TERCERO_INVITADO_INTENTO_RESTABLECIMIENTO_CLAVE", uts: { "ambito": "CREDITO" }
    };

    let selectedTipoGenericaFormularioRestablecimiento = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", tg: "BAS_VSTA_TERCERO_INVITADO_INTENTO_RESTABLECIMIENTO_CLAVE"
    };

    let selectedTipoGenericaFormularioRestablecimientoConfirmacionOpt = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", tg: "BAS_VSTA_TERCERO_INVITADO_INTENTO_RESTABLECIMIENTO_CONFIRMACION_OPT"
    };


    const etiquetasModulo = [{ "etiqueta": "DIALOG_HEADER_TEXT", "ctiTexto": "hola" }];


    const faqs = [
        {
            header: "¿Cuáles datos de mi carrera necesito para solicitar el crédito?",
            text: "Necesitas, nombre del programa académico, semestre a cursar y valor de la matrícula sin incluir el seguro estudiantil."
        },

        {
            header: "¿Puedo adelantar el pago de las cuotas de mi crédito?",
            text: "Si, en cualquier momento puedes realizar abonos al crédito y esto disminuye el valor de la cuota próxima a vencer."
        },

        {
            header: "¿Puedo cambiar la fecha del pago de mis cuotas?",
            text: "No, por defectos las fechas de vencimientos de las cuotas son los 30 días de cada mes."
        },

        {
            header: "¿Puedo cambiar el codeudor de mi solicitud de crédito?",
            text: "Si, pero antes de hacer el cambio, debes presentar los documentos del nuevo codeudor y pasar por el estudio de crédito inicial."
        },

        {
            header: "¿Puedo solicitar un crédito si soy menor de edad?",
            text: "Si, Puedes solicitar el crédito educativo por medio de un Responsable, apoderado o representante legal del Crédito, puede ser tu papá, mamá, hermano (a), tío (a), abuelo (a) o simplemente una persona responsable y de confianza."
        },

        {
            header: "¿Puedo solicitar un crédito sin codeudor?",
            text: "No, para realizar un crédito directo, es necesario cumplir con los requisitos de crédito, el cual estipula contar con un codeudor y que cumpla con unas condiciones."
        },

        {
            header: "¿No tengo ingresos estables, puedo solicitar un crédito?",
            text: "Los requisitos de crédito directo estipula una condición especial la cual es que el codeudor debe tener ingresos igual o superior a 2 SMLV."
        },

        {
            header: "¿Puedo financiar mi crédito si estoy reportado (a)?",
            text: "Si puedes financiar tu crédito, siempre y cuando cuentes con los requisitos del crédito."
        },

        {
            header: "¿Necesito orden de matrícula?",
            text: "Si, para realizar la solicitud del crédito es necesario contar con la liquidación u orden de matrícula para poder calcular el valor real a financiar."
        },

        {
            header: "¿Puedo financiar sólo un porcentaje de mi semestre?",
            text: "No, los requisitos de credito estipula que como minimo el 50% se puede financiar, solo para el caso de un codeudor asalariado con ingresos igual o superior a 2 SMLV puede financiar el 60% del valor de su matrícula."
        },

        {
            header: " ¿Cómo solicitar una devolución?",
            text: "<p>Las devoluciones se generan siempre y cuando existan 2 pagos de la matrícula. Adicionalmente, se debe realizar una solicitud de devolución siguiendo estos pasos:Elaborar una carta donde solicita la devolución del dinero dirigida a admisiones y registros.Copia del documento de identidad.Certificación bancariaDiligenciar formulario de reembolso, diligenciar solo hasta donde dice motivo.En caso de que el estudiante sea menor de edad, debe adjuntar copia del documento de identidad del acudiente, copia del documento del estudiante, copia del RUT (acudiente).Una vez tenga todos los documentos mencionados anteriormente, enviar la solicitud al correo: archivocentral@cecar.edu.co</p>"

        },

        {
            header: "Quiero pagar la totalidad de mi crédito, ¿qué debo hacer?",
            text: "Desde el sistema académico en la opción portal financiero puedes generar un recibo por el total del pago de la deuda, también te puedes acercar a nuestra oficina de crédito y cobranzas y de forma presencial se te entrega el recibo por el valor total de tu deuda."
        },

        {
            header: "¿Puedo cambiar el monto de mi crédito?",
            text: "No, solamente si hacer abonos parciales o si decides pagar un valor de la cuota inicial superior al 50%"
        },

        {
            header: "¿En qué entidades puedo realizar el pago de mis cuotas?",
            text: "Banco Popular, Banco Davivienda, Servientreg-aefecty, Exito, Banco De Occidente, Bancoomeva, Payu Colombia, S.A.S, Baloto, Banco De Bogota, Bbva, Colombia, Bancolombia, Banco Colpatria"
        },

        {
            header: "Instrucciones al estudiantes tras aprobación y firma de pagaré (dónde descargar recibo de pago, tiempo de espera mientras se genera recibo de pago..etc)",
            text: "Desde el sistema académico, en la opción portal financiero los estudiantes con crédito directo pueden visualizar las cuotas pactadas, fechas de vencimientos, generar facturas, abonos parciales y derechos académicos."
        },

    ];


    const formFacturaRef = useRef(null);

    const [submitted, setSubmitted] = useState(false);

    const [visibleSolicitarCredito, setVisibleSolicitarCredito] = useState(false);
    const [visibleIniciarSesion, setVisibleIniciarSesion] = useState(false);
    const [clientIP, setClientIP] = useState(undefined);

    const [visibleRetablecerClave, setVisibleRetablecerClave] = useState(false);

    const [guidIntento, setGuidIntento] = useState(window.crypto.randomUUID());
    const [editando, setEditando] = useState(false);

    const [lazyParams, setLazyParams] = useState(undefined);

    const lazyParamInit = {
        first: 0,
        rows: 10,
        page: 0,
        sortField: null,
        sortOrder: null,
        iteracion: 0,
        filters: {
            //'ctiTexto': { value: '', matchMode: FilterMatchMode.CONTAINS },
        }
    };


    const lazyParamsInitSelected = useRef(Object.assign({}, lazyParamInit));


    const toast = useRef(null);

    const selectedTipoGenerica = useRef({
        tg: "BPM_VSTA_SOLICITUD_CD_INVITADO_REFERENCIA_ORDEN_ACADEMICA_CALCULADORA",
        cti: "",
        ctiTexto: "",
        //orden: operaciontgRef.ordentgRef,
        //cgCampo: operaciontgRef.cgCampotgRef,
        operaciones: undefined,
        version: window.crypto.randomUUID(),
        tipoOrganizacionContenido: "TABLA",
        filtroUts: { "solicitud": 0 },
        ctiTextoFiltroUts: ""
    });

    const toggleMenuItemClick = () => {
        setIsHidden((prevState) => !prevState);
    };

    //                        <Link href="/" className="flex align-items-center">
    //                        <img src={`/layout/images/${layoutConfig.colorScheme === 'light' ? 'logo-dark' : 'logo-white'}.svg`} alt="Sakai Logo" height="50" className="mr-0 lg:mr-2" />
    //                       <span className="text-900 font-medium text-2xl line-height-3 mr-8">SAKAI</span>
    //                  </Link>


    const hideDialog = () => {
        setSubmitted(false);
        setGenericaSistemaDialogFormularioFactura(false);
        setGenericaSistemaDialogFormulario(false);
        setGenericaSistemaDialogFormularioRestablecimiento(false);
        setGenericaSistemaDialogFormularioAutoregistro(false);
        setVisibleSolicitarCredito(false);
        setVisibleRetablecerClave(false);
    }

    const clickSolicitarCredito = async (e) => {
        setIndiceDialog(0);
        setVisibleSolicitarCredito(true);
    }

    const clickIniciarSesion = async (e) => {

        setIndiceDialog(0);
        setVisibleIniciarSesion(true);
        setVisibleSolicitarCredito(false);
        setVisibleRetablecerClave(false);

        console.log("clickIniciarSesion, ");
        if (clientIP === undefined) {

            await authController.getClientIP().then(response => {

                setClientIP(response);
                op.current.toggle(e);

            });

        }
        else {
            op.current.toggle(e);
        }
    }

    const clickIniciarRegistro = async (e) => {
        //const onEditarFormularioFactura = async (e) => {

        //setEditando(true);

        var newGuid = window.crypto.randomUUID();

        //console.log(selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO);

        //let tgRefOps = selectedTipoGenerica.operacionesCampos.find(x => x.seccion === "FORMULARIO_CALIFICACION_INTENTO_TMP" && x.tipoOperacion === "FORMULARIO_CALIFICACION_CREAR_INTENTO")


        //setSelectedTipoGenerica(newSelectedTipoGenerica);

        let newGenericaSistema = {
            id: -1, idEmpresa: idEmpresa, idioma: idioma,
            tg: "BAS_VSTA_TERCERO_INVITADO_INTENTO_AUTOREGISTRO", uts: {}
        }
        newGenericaSistema.uts['solicitud'] = 0;
        newGenericaSistema.uts['guidIntento'] = newGuid;

        /*
        for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
            itemOpsCampo = newSelectedTipoGenerica.operacionesCampos[i];
            if (itemOpsCampo.id === tgRefOps.id) {
                genericaSistema.uts[itemOpsCampo.campotgRef] = genericasSistemaConsolidado.uts[itemOpsCampo.campotg];
            }

        }*/

        var tg = "BAS_VSTA_TERCERO_INVITADO_INTENTO_AUTOREGISTRO";



        /*

    
    
    genericaSistema[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];

    console.log("sende, ", genericaSistema);

    let dialog = genericaSistemaDialogRef.current;

    */



    }

    const clickIniciarSimulacion = async (e) => {
        //const onEditarFormularioFactura = async (e) => {

        //setEditando(true);

        var newGuid = window.crypto.randomUUID();

        //console.log(selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO);

        //let tgRefOps = selectedTipoGenerica.operacionesCampos.find(x => x.seccion === "FORMULARIO_CALIFICACION_INTENTO_TMP" && x.tipoOperacion === "FORMULARIO_CALIFICACION_CREAR_INTENTO")


        //setSelectedTipoGenerica(newSelectedTipoGenerica);

        let newGenericaSistema = { id: -1, idEmpresa: idEmpresa, idioma: idioma, tg: "BPM_VSTA_SOLICITUD_CD_INTENTO_CALCULADORA", uts: {} }
        newGenericaSistema.uts['solicitud'] = 0;
        newGenericaSistema.uts['guidIntento'] = newGuid;

        /*
        for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
            itemOpsCampo = newSelectedTipoGenerica.operacionesCampos[i];
            if (itemOpsCampo.id === tgRefOps.id) {
                genericaSistema.uts[itemOpsCampo.campotgRef] = genericasSistemaConsolidado.uts[itemOpsCampo.campotg];
            }

        }*/

        await genericaSistemaService.saveGenericaSistema(idEmpresa, idioma, userName, newGenericaSistema).then(response => {

            if (response.mensaje === "") {


                setTimeout(() => {

                    setGuidIntento(newGuid);
                    setEditando(true);

                    console.log("newGuid, ", newGuid);

                    //establecerTipoGenericasFORMULARIO_CALIFICACION(metadataGenericaSistemaTgOperaciones, true, newGuid);

                    lazyParamInit.filters = {};
                    let newLazyParamInit = Object.assign({}, lazyParamInit);
                    setLazyParams({ ...newLazyParamInit });
                    lazyParamsInitSelected.current = newLazyParamInit;


                    setGenericaSistemaDialogFormularioFactura(true)

                    formFacturaRef.current.onEditarFormularioFactura(null, newGenericaSistema);

                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Actualizado', life: 3000 });
                }, 100);



                //props.onSaveSuccessful(_genericaSistema, idOriginal, response.genericasSistemaAffected);

                //setGenericasSistema(_genericasSistema);
                //setGenericaSistemaDialog(false);
                //setGenericaSistema(crearNewEmptyGenerica(metadataGenericaSistemaForm));
            }
            else {
                toast.current.show({ severity: 'error', summary: 'Error Message', detail: response.mensaje });
            }

        });


        /*

    
    
    genericaSistema[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];

    console.log("sende, ", genericaSistema);

    let dialog = genericaSistemaDialogRef.current;

    */



    }


    console.log("formFacturaRef, ", formFacturaRef);

    const headerTemplate = (options) => {
        const className = `${options.className} justify-content-space-between`;

        return (
            <div className={className}>
                <div className="flex align-items-center gap-2">

                    <Button icon="pi pi-question" rounded raised style={{ fontSize: '1.5rem' }} />

                    <span className="font-bold">{options.props.header}</span>
                </div>

            </div>
        );
    };

    const seccionfaq = () => {

        return faqs.map((x, index) => {
            let _text = x.text;
            return (<Panel key={index} className="text-gray-900 gray-90text-0 text-2xl p-3" headerTemplate={headerTemplate} style={{ width: "100%" }}
                header={x.header}>
                <div className="m-0 text-xl p-3" dangerouslySetInnerHTML={{ __html: _text }} />


            </Panel>);
        });

    };

    const onSaveSuccessfulFormulario = (_genericaSistema, idOriginal, genericasSistemaAffect) => {

        hideDialog();


        if (_genericaSistema.tg === "BAS_VSTA_TERCERO_INVITADO_INTENTO_RESTABLECIMIENTO_CONFIRMACION_OPT") {
            console.log("_genericaSistema, ", _genericaSistema);
        }


    }

    const onClickContentDialog = async (index) => {

        console.log("setIndiceDialog_index, ", index);

        if (index === 4) {  //Para registro

            let tg = "BAS_VSTA_TERCERO_INVITADO_INTENTO_AUTOREGISTRO";

            await genericaSistemaService.getMetadataGenericasSistema(tg, idEmpresa, idioma, userName).then(data => {

                let newGenerica = { ...emptyGenericaSistemaInitAutorregistro };
                setGenericaFormularioFacturaAutoregistro(newGenerica);
                setMetadataGenericaFormularioFacturaAutoregistro(data);
                setIndiceDialog(index);
                setGenericaSistemaDialogFormularioAutoregistro(true);
                setVisibleSolicitarCredito(true);
                setVisibleRetablecerClave(false);
            });

            //setIndiceDialog(index);

        }
        else if (index === 5) {  //Para Restablecimiento

            let tg = "BAS_VSTA_TERCERO_INVITADO_INTENTO_RESTABLECIMIENTO_CLAVE";

            await genericaSistemaService.getMetadataGenericasSistema(tg, idEmpresa, idioma, userName).then(data => {

                let newGenerica = { ...emptyGenericaSistemaInitRestablecimiento };
                setGenericaFormularioFacturaRestablecimiento(newGenerica);
                setMetadataGenericaFormularioFacturaRestablecimiento(data);
                setIndiceDialog(index);
                setGenericaSistemaDialogFormularioRestablecimiento(true);
                setVisibleSolicitarCredito(false);
                setVisibleRetablecerClave(true);

            });

            //setIndiceDialog(index);

        }



        setIndiceDialog(index);

    }


    const [indiceDialog, setIndiceDialog] = useState(0);

    const cuentaQuienEres = (<>

        <div className="m-1 col-12 my-auto flex flex-column text-center lg:text-left lg:align-items-center"
            style={{ paddingTop: "0" }}>

            <h2 className="line-height-1 text-4xl font-normal text-green-600">CUÉNTANOS QUIÉN ERES</h2>


            <span className="text-700 text-2xl line-height-3 mr-0 md:mr-2" style={{ maxWidth: '650px' }}>
                <strong>IMPORTANTE:</strong> La solicitud de financiación puede ser solicitada por el mismo estudiante, si es mayor de edad, o por un tercero responsable, quien será la persona que debe registrarse en la plataforma.
            </span>

            <div className='mt-4 flex' style={{ width: "90%" }}>
                <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png" className="mr-3" size="xlarge" shape="circle" style={{ width: "7rem", height: "7rem" }} />
                <Button style={{ width: "90%" }} className='bg-white text-2xl text-green-600 surface-border' label="Soy el estudiante y soy menor de edad"
                    severity="secondary" outlined onClick={(e) => onClickContentDialog(1)} />

            </div>

            <div className='mt-4 flex' style={{ width: "90%" }}>
                <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png" className="mr-3" size="xlarge" shape="circle" style={{ width: "7rem", height: "7rem" }} />
                <Button style={{ width: "90%" }} className='mt-4 bg-white text-2xl text-green-600 surface-border' label="Soy el estudiante, soy mayor de edad y me haré responsable de la financiación de mi matrícula"
                    onClick={(e) => onClickContentDialog(2)} severity="secondary" outlined />

            </div>

            <div className='mt-4 flex' style={{ width: "90%" }}>
                <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png" className="mr-3" size="xlarge" shape="circle" style={{ width: "7rem", height: "7rem" }} />
                <Button style={{ width: "90%" }} className='mt-4 bg-white text-2xl text-green-600 surface-border' label="No soy el estudiante, me haré responsable de la financiación de matrícula de alguien más"
                    onClick={(e) => onClickContentDialog(3)} severity="secondary" outlined />

            </div>


        </div>

    </>);

    const estudianteMenorDeEdad = (<>

        <div className="m-1 col-12 my-auto flex flex-column text-center lg:text-left lg:align-items-center"
            style={{ paddingTop: "0" }}>

            <h2 className="line-height-1 text-4xl font-normal text-green-600">CUÉNTANOS QUIÉN ERES</h2>


            <span className="mt-4 text-700 text-2xl line-height-3 mr-0 md:mr-2" style={{ maxWidth: '650px' }}>
                ¡Debes pedirle a alguien más que se registre y solicite la financiación por ti!
            </span>

            <span className="mt-4 text-700 text-2xl line-height-3 mr-0 md:mr-2" style={{ maxWidth: '650px' }}>
                <strong>Importante:</strong>Por restricciones de ley no es posible que una persona menor de edad se haga cargo de una obligación financiera, firme garantías de pago y demás trámites necesarios. Te invitamos a pedirle a un adulto responsable con cédula de ciudadanía, a que se registre en la plataforma y solicite la financiación por ti.
            </span>

            <Button style={{ width: "90%" }} className='mt-4 bg-white text-2xl text-green-600 surface-border'
                label="Regresar" severity="secondary" outlined onClick={(e) => onClickContentDialog(0)} />


        </div>

    </>);

    const mayorDeEdad = (<>

        <div className="m-1 col-12 my-auto flex flex-column text-center lg:text-left lg:align-items-center"
            style={{ paddingTop: "0" }}>

            <h2 className="line-height-1 text-4xl font-normal text-green-600">CUÉNTANOS QUIÉN ERES</h2>

            <p className="mt-4 text-700 text-2xl line-height-3 mr-0 md:mr-2 text-justify" style={{ maxWidth: '650px' }}>
                Ten presente que por el momento, solo se aceptan solicitantes mayores de edad identificados con cédula de ciudadanía colombiana y la aprobación de la solicitud de financiación estará sujeta a un estudio crediticio que incluye consulta a centrales de riesgo.

                <br></br>

                Al registrarte y realizar la solicitud de financiación te harás responsable del pago de las cuotas y las obligaciones derivadas de la misma y serás quien firme el pagaré digital.

                <br></br>


                Si tu solicitud de financiación resulta aprobada, debes realizar el pago de la cuota inicial para que tu financiación quede legalizada.

                <br></br>

            </p>

            <Button style={{ width: "90%" }} className='mt-4 bg-white text-2xl text-green-600 surface-border'
                label="Registrarse" severity="secondary" outlined onClick={(e) => onClickContentDialog(4)} />

            <Button style={{ width: "90%" }} className='mt-4 bg-white text-2xl text-green-600 surface-border'
                label="Regresar" severity="secondary" outlined onClick={(e) => onClickContentDialog(0)} />

        </div>

    </>);

    const registro = (<>


        <div className=" align-items-centerm-1 col-12 my-auto flex flex-column text-center lg:text-left lg:align-items-center border-round-md "
            style={{ paddingTop: "0" }}>

            <div style={{ width: '90%', maxHeight: '80%', zIndex: "6" }}>

                <h2 className="line-height-1 text-4xl font-normal text-green-600" style={{ textAlign: "center" }}>Autorización para el tratamiento de datos personales</h2>

                <p className='mt-4 text-700 text-2xl line-height-3 mr-0 md:mr-2 text-justify'>
                    Autorizo expresa e irrevocablemente a Corporación Universitaria del Caribe de forma libre y voluntariamente, para que reporte, consulte y divulgue a la Asociación Bancaria y de entidades Financieras de Colombia ASOBANCARIA, Datacrédito, CIFIN o a cualquier otro operador y/o fuente de información legalmente establecido, toda la información referente a mi comportamiento como estudiante o representante del estudiante que se relaciones con el nacimiento, ejecución modificación, liquidación y/o extinción de las obligaciones que se deriven de la relación jurídica en virtud de la cual Corporación Universitaria del Caribe me dio plazo de pago para cubrir mis obligaciones pecuniarias, en cualquier tiempo, y que podrá reflejarse en las bases de datos de la CIFIN, DATACREDITO o de cualquier otro operador y/o fuente de información legalmente establecido. La permanencia de la información estará sujeta a los principios, términos y condiciones consagrados en la ley 1266 de 2008 y demás normas que lo modifiquen, aclaren o reglamenten.
                    En este sentido autorizo, expresa e irrevocablemente a Corporación Universitaria del Caribe para que consulte toda la información financiera, crediticia, comercial, de servicios y la proveniente de otros países, atinente a mis relaciones comerciales que tenga con el Sistema Financiero, comercial y de servicios, o de cualquier sector, tanto en Colombia como en el Exterior, en cualquier tiempo.
                    Adicionalmente, la presente autorización se extiende para que Corporación Universitaria del Caribe puede compartir información con terceros públicos o privados, bien sea que estos ostenten la condición de fuentes de información, operadores de información o usuarios, administradores y gestores de cobro de cartera, con quienes Corporación Universitaria del Caribe tenga vínculos jurídicos de cualquier naturaleza.
                    Quien suministre información que no corresponda a la realidad podría incurrir en el delito de falsedad en documento privado.


                </p>


                <h2 className="line-height-1 text-4xl font-normal text-green-600" style={{ textAlign: "center" }}>Registra tus datos</h2>
                <p className='mt-4 text-700 text-2xl line-height-3 mr-0 md:mr-2 text-justify'>
                    <strong>Importante:</strong> Por favor, ingresa tus datos exactamente igual a como se muestran en tu documento de identidad.
                    Recueda que únicamente debe registrarse el deudor o titular de la solicitud.
                </p>

                <Formulario className="text-4xl"  //ref={formRef} 
                    genericaSistemaDialog={genericaSistemaDialogFormularioAutoregistro} genericaSistema={genericaFormularioFacturaAutoregistro}
                    metadataGenericaSistemaForm={metadataGenericaFormularioFacturaAutoregistro}
                    etiquetasModulo={etiquetasModulo} selectedTipoGenerica={selectedTipoGenericaFormularioAutoregistro}
                    utilizaDialog={false} style={{ width: "100%" }}
                    onHideForm={hideDialog} requiereConfirmacionOPT={true} selectedTipoGenericaConfirmacionOPT={selectedTipoGenericaFormularioAutoregistroConfirmacionOpt}
                    onSaveSuccessful={onSaveSuccessfulFormulario}
                ></Formulario>

            </div>

            <Button style={{ width: "90%" }} className='mt-4 bg-white text-2xl text-green-600 surface-border'
                label="Regresar" severity="secondary" outlined onClick={(e) => onClickContentDialog(0)} />

        </div>

    </>);

    const restablecimiento = (<>


        <div className=" align-items-centerm-1 col-12 my-auto flex flex-column text-center lg:text-left lg:align-items-center border-round-md "
            style={{ paddingTop: "0" }}>

            <div style={{ width: '90%', maxHeight: '80%', zIndex: "6" }}>

                <h2 className="line-height-1 text-4xl font-normal text-green-600" style={{ textAlign: "center" }}>Autorización para el tratamiento de datos personales</h2>

                <p className='mt-4 text-700 text-2xl line-height-3 mr-0 md:mr-2 text-justify'>
                    Autorizo expresa e irrevocablemente a Corporación Universitaria del Caribe de forma libre y voluntariamente, para que reporte, consulte y divulgue a la Asociación Bancaria y de entidades Financieras de Colombia ASOBANCARIA, Datacrédito, CIFIN o a cualquier otro operador y/o fuente de información legalmente establecido, toda la información referente a mi comportamiento como estudiante o representante del estudiante que se relaciones con el nacimiento, ejecución modificación, liquidación y/o extinción de las obligaciones que se deriven de la relación jurídica en virtud de la cual Corporación Universitaria del Caribe me dio plazo de pago para cubrir mis obligaciones pecuniarias, en cualquier tiempo, y que podrá reflejarse en las bases de datos de la CIFIN, DATACREDITO o de cualquier otro operador y/o fuente de información legalmente establecido. La permanencia de la información estará sujeta a los principios, términos y condiciones consagrados en la ley 1266 de 2008 y demás normas que lo modifiquen, aclaren o reglamenten.
                    En este sentido autorizo, expresa e irrevocablemente a Corporación Universitaria del Caribe para que consulte toda la información financiera, crediticia, comercial, de servicios y la proveniente de otros países, atinente a mis relaciones comerciales que tenga con el Sistema Financiero, comercial y de servicios, o de cualquier sector, tanto en Colombia como en el Exterior, en cualquier tiempo.
                    Adicionalmente, la presente autorización se extiende para que Corporación Universitaria del Caribe puede compartir información con terceros públicos o privados, bien sea que estos ostenten la condición de fuentes de información, operadores de información o usuarios, administradores y gestores de cobro de cartera, con quienes Corporación Universitaria del Caribe tenga vínculos jurídicos de cualquier naturaleza.
                    Quien suministre información que no corresponda a la realidad podría incurrir en el delito de falsedad en documento privado.


                </p>


                <h2 className="line-height-1 text-4xl font-normal text-green-600" style={{ textAlign: "center" }}>Registra tus datos</h2>
                <p className='mt-4 text-700 text-2xl line-height-3 mr-0 md:mr-2 text-justify'>
                    <strong>Importante:</strong> Por favor, ingresa tus datos exactamente igual a como se muestran en tu documento de identidad.
                    Recueda que únicamente debe registrarse el deudor o titular de la solicitud.
                </p>

                <Formulario className="text-4xl"  //ref={formRef} 
                    genericaSistemaDialog={genericaSistemaDialogFormularioRestablecimiento} genericaSistema={genericaFormularioFacturaRestablecimiento}
                    metadataGenericaSistemaForm={metadataGenericaFormularioFacturaRestablecimiento}
                    etiquetasModulo={etiquetasModulo} selectedTipoGenerica={selectedTipoGenericaFormularioRestablecimiento}
                    utilizaDialog={false} style={{ width: "100%" }}
                    onHideForm={hideDialog} requiereConfirmacionOPT={true} selectedTipoGenericaConfirmacionOPT={selectedTipoGenericaFormularioRestablecimientoConfirmacionOpt}
                    onSaveSuccessful={onSaveSuccessfulFormulario}
                ></Formulario>

            </div>

            <Button style={{ width: "90%" }} className='mt-4 bg-white text-2xl text-green-600 surface-border'
                label="Regresar" severity="secondary" outlined onClick={(e) => onClickContentDialog(0)} />

        </div>

    </>);


    const arrayContectDialog = [cuentaQuienEres, estudianteMenorDeEdad, mayorDeEdad, mayorDeEdad, registro, restablecimiento]

    const contentDialog = (index) => {
        console.log("index, ", index);

        return (arrayContectDialog[index]);


    }

    const [formAsVisit, setFormAsVisit] = useState({
        idSuscripcion: idSuscripcion,
        idioma: idiomaInit,
        idEmpresa: idEmpresaInit,
        subdomain: subdomain,
        userName: 'guest',
        password: ''
    });

    const onInputChangeAsVisit = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _formAsVisit = { ...formAsVisit };
        _formAsVisit[`${name}`] = val;
        setFormAsVisit(_formAsVisit);
    }

    const clickAsVisit = async (e) => {

        let newTextoError = "";

        //e.preventDefault();
        try {

            if (formAsVisit.documento !== undefined && formAsVisit.password !== undefined
                && formAsVisit.documento !== "" && formAsVisit.password !== "") {

                let _loginDataGuest = { ...formAsVisit, documentoInvitado: formAsVisit.documento };
                _loginDataGuest.userName = _loginDataGuest.documento + "/" + modExternal + "/guest";

                //console.log(props.nextProps);

                let response = await authController.loginVisitUser(_loginDataGuest) //loginUser action makes the request and handles all the neccessary state changes

                if (response.sessionGUID !== null && response.sessionGUID !== "") {

                    if (props.onLoginGuest) {
                        props.onLoginGuest(response);
                    }

                    window.location.href = process.env.NEXT_PUBLIC_FOLDER_APP + "/homeguest";
                    //window.location.href ='/generica2'; //navigate to dashboard on success
                }
                else {

                    setIntentoErrado((prev) => prev + 1);
                    newTextoError = "Falló la autentificación: Ingresaste un documento y/o contraseña incorrecta.";

                }


                /*
            setUsernameDiligenciador(userName);
            let newSelectedTipoGenerica = { ...selectedTipoGenerica }
            newSelectedTipoGenerica.filtroUts['usernametercero'] = userName;
            newSelectedTipoGenerica.filtroUts['documentoInvitadoSolicitante'] = formAsVisit.documentoInvitado;
            newSelectedTipoGenerica.filtroUts['usernametercero'] = formAsVisit.documentoInvitado;
*/

                /*
                if (selectedTipoGenerica.tg === "FMT_VSTA_FORMATO_PENDIENTE_EMPLEADOR" ||
                    (idEmpresa === 2 && selectedTipoGenerica.tg === "FMT_VSTA_FORMATO_PENDIENTE_DIRECTIVO")
                ) {
                    newSelectedTipoGenerica.filtroUts['documentotercero'] = formAsVisit.documentoInvitado;
                }
                else if (selectedTipoGenerica.tg.includes("FMT_VSTA_FORMATO_PENDIENTE_") && selectedTipoGenerica.tg !== "FMT_VSTA_FORMATO_PENDIENTE_EMPLEADOR") {
                    newSelectedTipoGenerica.filtroUts['documentotercero'] = formAsVisit.documentoInvitado;
                    newSelectedTipoGenerica.filtroUts['usernametercero'] = formAsVisit.documentoInvitado;
                }
                else {
                    newSelectedTipoGenerica.filtroUts['documentoInvitado'] = formAsVisit.documentoInvitado;
                }
                    */


                //setSelectedTipoGenerica(newSelectedTipoGenerica);

                //window.location.href ='/generica2'; //navigate to dashboard on success
            }
            else {
                newTextoError = "Debe ingresar documento y contraseña";
            }


        } catch (error) {
            console.log(error)
        }

        setVecesBotonPresionado(prev => prev + 1);
        setTextoError(newTextoError);

    }

    const contentLogin = (<>


        <div className="flex flex-column md:flex-row w-full">

            <div className="w-full flex flex-column align-items-center justify-content-center gap-3 py-5">
                <div className="flex flex-wrap justify-content-center align-items-center gap-2">
                    <label className="w-full">Credenciales de Acceso </label>
                </div>
                <div className="w-full">

                    <label className="w-full">Usuario</label>
                    <InputText id="documentoInvitado" type="text" onChange={(e) => onInputChangeAsVisit(e, 'documento')} className="w-full" />
                </div>
                <div className="w-full">
                    <label className="w-6rem">Clave</label>
                    <InputText id="password" type="password" onChange={(e) => onInputChangeAsVisit(e, 'password')} className="w-full" />
                </div>

                <label ref={labelErrorRef} className="">{textoError}</label>

                <Button label="Ingresar" onClick={clickAsVisit} icon="pi pi-user" className="w-full"></Button>

                <div class="grid">

                    <Button label="¿Olvidaste tu contraseña?" link onClick={(e) => onClickContentDialog(5)} icon="" className="col"></Button>

                    <Button label="Regístrate" link onClick={(e) => onClickContentDialog(4)} icon="" className="col"></Button>



                </div>

                <div className="flex flex-wrap justify-content-center align-items-center gap-2">
                    <label className="w-full">Importante: Por motivos de seguridad su acceso está siendo monitoreado</label>
                </div>

                <div className="flex flex-wrap justify-content-center align-items-center gap-2">
                    <label className="w-full">IP: {clientIP}</label>
                </div>

            </div>

        </div>

    </>);


    return (<>

        <Toast ref={toast} />

        <Dialog id="dialogGenericaSistemaForm"
            /*ref={genericaSistemaDialogRef}
                            
                            header={GetTextoEtiqueta("DIALOG_HEADER_TEXT") + " " + genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0].uts['ctiTextoformato']} modal className="p-fluid"
                            footer={genericaSistemaDialogFooter()}
                            
                            closable={props.onHideForm !== undefined}
                        */

            style={{ width: '100%' }} resizable={false} position='top' closable={true}
            onHide={(e) => setVisibleSolicitarCredito(false)}
            visible={visibleSolicitarCredito}>
            {contentDialog(indiceDialog)}
        </Dialog>

        <Dialog id="dialogRestablecimientoClave"
            /*ref={genericaSistemaDialogRef}
                            
                            header={GetTextoEtiqueta("DIALOG_HEADER_TEXT") + " " + genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0].uts['ctiTextoformato']} modal className="p-fluid"
                            footer={genericaSistemaDialogFooter()}
                            
                            closable={props.onHideForm !== undefined}
                        */

            style={{ width: '100%' }} resizable={false} position='top' closable={true}
            onHide={(e) => setVisibleRetablecerClave(false)}
            visible={visibleRetablecerClave}>
            {contentDialog(indiceDialog)}
        </Dialog>

        <Dialog id="dialoginiciarSesion"
            /*ref={genericaSistemaDialogRef}
                            
                            header={GetTextoEtiqueta("DIALOG_HEADER_TEXT") + " " + genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0].uts['ctiTextoformato']} modal className="p-fluid"
                            footer={genericaSistemaDialogFooter()}
                            
                            closable={props.onHideForm !== undefined}
                        */

            style={{ width: '100%' }} resizable={false} position='top' closable={true}
            onHide={(e) => setVisibleIniciarSesion(false)}
            //visible={visibleIniciarSesion}
            visible={false}>
            {contentLogin}
        </Dialog>

        <OverlayPanel ref={op} showCloseIcon style={{ 'margin-top': '2%', 'margin-left': '2%' }}
            className="overlaypanel-demo w-8 lg:w-3" target={btInicioSesion.current}>
            {contentLogin}
        </OverlayPanel>

        <div className="surface-0" style={{ position: "fixed", zIndex: "10", width: "100%" }}>



            <div className="py-4 px-4 mx-0 px-8 grid align-items-center justify-content-between static">

                <div className='col-4 flex justify-content-end  align-items-end surface-0 flex-grow-1 justify-content-between flex ' style={{ top: '100%' }}>

                    <img src="https://aldea.cecar.edu.co/Assets/images/ecosic/logo.png" alt="Cecar" width="250px" height="50" />

                </div>

                <div className={classNames('col-4 align-items-center surface-0 flex-grow-1 justify-content-between hidden md:flex   absolute md:static left-0 px-6 lg:px-0 z-2', { hidden: isHidden })} style={{ top: '100%' }}>
                    <ul className="list-none p-0 m-0 flex lg:align-items-center select-none flex-column md:flex-row cursor-pointer">
                        <li>
                            <a href="#home" onClick={toggleMenuItemClick} className="text-2xl  p-ripple flex m-0 md:ml-5 py-3 text-900 font-medium line-height-3">
                                <span>Inicio</span>
                                <Ripple />
                            </a>
                        </li>
                        <li>
                            <a href="#features" onClick={toggleMenuItemClick} className="text-2xl  p-ripple flex m-0 md:ml-5 px-0 py-3 text-900 font-medium line-height-3">
                                <span>Preguntas Frecuentes</span>
                                <Ripple />
                            </a>
                        </li>
                        <li>
                            <a href="#highlights" onClick={toggleMenuItemClick} className="text-2xl  p-ripple flex m-0 md:ml-5 px-0 py-3 text-900 font-medium line-height-3">
                                <span>Simular Financiación</span>
                                <Ripple />
                            </a>
                        </li>
                        <li>
                            <a href="#pricing" onClick={toggleMenuItemClick} className="text-2xl p-ripple flex m-0 md:ml-5 px-0 py-3 text-900 font-medium line-height-3">
                                <span>Beneficios</span>
                                <Ripple />
                            </a>
                        </li>
                    </ul>

                </div>

                <div className='col-4 flex justify-content-end  align-items-end surface-0 flex-grow-1 ' style={{ top: '100%' }}>


                    <Button label="Iniciar sesión" ref={btInicioSesion} rounded className="text-xl border-none ml-5 font-light line-height-2 bg-blue-500 text-white"
                        onClick={clickIniciarSesion}></Button>



                </div>

            </div>



        </div>


        <div className="surface-0 flex justify-content-center">
            <div id="home2" className="landing-wrapper overflow-hidden">


                <div id="home" className="py-4 px-4 lg:px-8 mx-0 my-6 lg:mx-8">
                    <div className="grid my-8 pt-2 md:pt-8">


                        <div className="col-12 lg:col-6 my-auto flex flex-column text-center lg:text-left lg:align-items-start seccionCredito"
                            style={{ paddingTop: "0" }}>


                            <div className="headerImg">
                                <img src="https://aldea.cecar.edu.co/Assets/images/ecosic/500x600.caeef8c505bb5895.png" alt="Cecar" width="100%" height="500px" />
                            </div>

                            <div className='CreditoTexto' >
                                &nbsp;
                            </div>

                        </div>

                        <div className="seccionCredito flex justify-content-center flex-order-1 sm:flex-order-2 col-12 lg:col-6 p-0" style={{ borderRadius: '8px' }}>


                            <div className="m-1 col-12 lg:col-6 my-auto flex flex-column text-center lg:text-left lg:align-items-start seccionCondicionesCredito"
                                style={{ paddingTop: "0" }}>

                                <h2 className="line-height-1 text-4xl font-normal">CrediCECAR</h2>
                                <span className="text-2xl line-height-3 mr-0 md:mr-2" style={{ maxWidth: '650px' }}>
                                    Regístrate o inicia Sesión
                                </span>

                                <Divider className="w-full bg-surface-200"></Divider>

                                <span className="text-2xl line-height-3 mr-0 md:mr-2" style={{ maxWidth: '650px' }}>
                                    Diligencia el formulario de financiación.
                                </span>

                                <Divider className="w-full bg-surface-200"></Divider>

                                <span className="text-2xl line-height-3 mr-0 md:mr-2" style={{ maxWidth: '650px' }}>
                                    Ingresa tus datos personales y de matricula.
                                </span>

                                <Divider className="w-full bg-surface-200"></Divider>

                                <span className="text-2xl line-height-3 mr-0 md:mr-2" style={{ maxWidth: '650px' }}>
                                    Una vez aprobada la financiación, firma el pagaré digital.
                                </span>

                                <Divider className="w-full bg-surface-200"></Divider>

                                <Button type="button" label="Solicita tu crédito aquí" rounded className="text-xl border-none mt-3 bg-blue-500 font-normal line-height-3 px-3 text-white"
                                    style={{ width: "100%", height: "100%" }}
                                    onClick={clickSolicitarCredito}>
                                </Button>

                            </div>

                        </div>
                    </div>
                </div>

                <div id="highlights" className="py-4 px-4 lg:px-8 mx-0 my-6 lg:mx-8">
                    <div className="text-center">
                        <h2 className="text-900 font-bold mb-2">Línea de financiación</h2>
                    </div>


                    <div className="grid my-8 pt-2 md:pt-8">


                        <div className="col-12 lg:col-6 my-auto flex flex-column text-center lg:text-left lg:align-items-start seccionSimulador"
                            style={{ paddingTop: "0" }}>


                            <div className="headerImg">
                                <img src="https://aldea.cecar.edu.co/Assets/images/ecosic/linea1.76a811bbf24d008b.png" alt="Cecar" width="100%" height="500px" />
                            </div>

                            <div className='SimuladorTexto' >
                                &nbsp;
                            </div>

                        </div>

                        <div className="seccionSimulador flex justify-content-center flex-order-1 sm:flex-order-2 col-12 lg:col-6 p-0" style={{ borderRadius: '8px' }}>

                            <div className="col-12 lg:col-6 my-auto flex flex-column text-center lg:text-left lg:align-items-start seccionCondicionesCredito"
                                style={{ paddingTop: "0" }}>

                                <h2 className="line-height-1 text-4xl font-normal">CrediCECAR</h2>
                                <span className="text-2xl line-height-3 mr-0 md:mr-2" style={{ maxWidth: '650px' }}>
                                    Financia el 60% y 50% de tu matrícula
                                </span>

                                <Divider className="w-full bg-surface-200"></Divider>

                                <span className="text-2xl line-height-3 mr-0 md:mr-2" style={{ maxWidth: '650px' }}>
                                    Cuota inicial: 40% y 50% de anticipo
                                </span>

                                <Divider className="w-full bg-surface-200"></Divider>

                                <span className="text-2xl line-height-3 mr-0 md:mr-2" style={{ maxWidth: '650px' }}>
                                    Paga de 2 a 4 cuotas
                                </span>

                                <Divider className="w-full bg-surface-200"></Divider>

                                <span className="text-2xl line-height-3 mr-0 md:mr-2" style={{ maxWidth: '650px' }}>
                                    Seguro de Fianza con el Fondo de Garantías
                                </span>

                                <Divider className="w-full bg-surface-200"></Divider>

                                <span className="text-2xl line-height-3 mr-0 md:mr-2" style={{ maxWidth: '650px' }}>
                                    Pagos: Días 30 de cada mes
                                </span>


                                <Button type="button" label="Simular Financiación" rounded className="text-xl border-none mt-3 bg-blue-500 font-normal line-height-3 px-3 text-white"
                                    style={{ width: "100%", height: "100%" }}
                                    onClick={clickIniciarSimulacion}>
                                </Button>


                                <FormularioCalculadoraCredito ref={formFacturaRef} genericaSistemaDialog={genericaSistemaDialogFormularioFactura} genericaSistema={genericaFormularioFactura}
                                    metadataGenericaSistemaForm={metadataGenericaFormularioFactura}
                                    etiquetasModulo={etiquetasModulo} selectedTipoGenerica={selectedTipoGenerica.current}
                                    onHideForm={hideDialog} ></FormularioCalculadoraCredito>

                            </div>

                        </div>
                    </div>
                </div>

                <div id="pricing" className="py-4 px-4 lg:px-8 my-2 md:my-4">
                    <div className="text-center">
                        <h2 className="text-900 font-bold mb-2">Beneficios</h2>
                    </div>

                    <div className="grid justify-content-between mt-8 md:mt-0">
                        <div className="col-12 lg:col-4 p-0 md:p-3">
                            <div className="p-3 flex flex-column border-200 pricing-card cursor-pointer border-2 hover:border-primary transition-duration-300 transition-all">
                                <h3 className="text-900 text-center my-5">Trámite 100% online</h3>
                                <img src="https://aldea.cecar.edu.co/Assets/images/ecosic/card_1.png" className="w-10 h-10 mx-auto" alt="free" />

                                <Divider className="w-full bg-surface-200"></Divider>
                                <ul className="my-5 list-none p-0 flex text-900 flex-column">
                                    <li className="py-2">
                                        <i className="pi pi-fw pi-check text-xl text-cyan-500 mr-2"></i>
                                        <span className="text-xl line-height-3">Sin necesidad de desplazarse a otro lugar, Conoce en todo momento el estado de tu solicitud.</span>
                                    </li>
                                    <li className="py-2">
                                        <i className="pi pi-fw pi-check text-xl text-cyan-500 mr-2"></i>
                                        <span className="text-xl line-height-3">Firma de pagaré 100% Digital.</span>
                                    </li>
                                    <li className="py-2">
                                        &nbsp;
                                    </li>

                                </ul>
                            </div>
                        </div>

                        <div className="col-12 lg:col-4 p-0 md:p-3 mt-4 md:mt-0">
                            <div className="p-3 flex flex-column border-200 pricing-card cursor-pointer border-2 hover:border-primary transition-duration-300 transition-all">
                                <h3 className="text-900 text-center my-5">Aprobación inmediata</h3>
                                <img src="https://aldea.cecar.edu.co/Assets/images/ecosic/card_2.png" className="w-10 h-10 mx-auto" alt="startup" />
                                <Divider className="w-full bg-surface-200"></Divider>
                                <ul className="my-5 list-none p-0 flex text-900 flex-column">
                                    <li className="py-2">
                                        <i className="pi pi-fw pi-check text-xl text-cyan-500 mr-2"></i>
                                        <span className="text-xl line-height-3">Sin filas, sin papeleos y sin complicaciones.</span>

                                    </li>
                                    <li className="py-2">
                                        <i className="pi pi-fw pi-check text-xl text-cyan-500 mr-2"></i>
                                        <span className="text-xl line-height-3">Aprobación en menos de 1 minuto.</span>
                                    </li>
                                    <li className="py-2">
                                        <i className="pi pi-fw pi-check text-xl text-cyan-500 mr-2"></i>
                                        <span className="text-xl line-height-3">Si no cuentas con ingresos o si eres menor de 18 años, la solicitud la puede presentar una persona diferente.</span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-12 lg:col-4 p-0 md:p-3 mt-4 md:mt-0">
                            <div className="p-3 flex flex-column border-200 pricing-card cursor-pointer border-2 hover:border-primary transition-duration-300 transition-all">
                                <h3 className="text-900 text-center my-5">Financiación directa</h3>
                                <img src="https://aldea.cecar.edu.co/Assets/images/ecosic/card_3.png" className="w-10 h-10 mx-auto" alt="enterprise" />

                                <Divider className="w-full bg-surface-200"></Divider>
                                <ul className="my-5 list-none p-0 flex text-900 flex-column">
                                    <li className="py-2">
                                        <i className="pi pi-fw pi-check text-xl text-cyan-500 mr-2"></i>
                                        <span className="text-xl line-height-3">Financia tu matrícula directamente con la universidad.</span>

                                    </li>
                                    <li className="py-2">
                                        <i className="pi pi-fw pi-check text-xl text-cyan-500 mr-2"></i>
                                        <span className="text-xl line-height-3">No necesitas experiencia crediticia ni ingresos elevados, te ofrecemos una hasta tasa del 1,5 M.V.</span>
                                    </li>
                                    <li className="py-2">
                                        &nbsp;
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="features" className="py-4 px-4 lg:px-8 mt-5 mx-0 lg:mx-8">
                    <div className="grid justify-content-center">
                        <div className="col-12 text-center mt-8 mb-4">
                            <h2 className="text-900 font-bold mb-2">Preguntas Frecuentes</h2>
                            <span className="text-600 text-2xl">...</span>
                        </div>

                        {seccionfaq()}


                    </div>





                </div>


                <div className="py-4 px-4 mx-0 mt-8 lg:mx-8 appFooter">

                    <div className="grid justify-content-between" >
                        <div className="col-12">
                            <div className="grid text-center md:text-left">
                                <div className="col-12 md:col-3">
                                    <a className="line-height-3 text-white text-xl block cursor-pointer mb-2 text-700" href="https://cecar.edu.co/">
                                        <img src="https://cecar.edu.co/images/logow.png" alt="Cecar" width="60%" height="50" className="mr-2" />
                                    </a>
                                    <p className="line-height-3 text-white text-xl block mb-2 text-700">
                                        VIGILADA MINEDUCACIÓN</p>
                                    <p className="line-height-3 text-white text-xl block mb-2 text-700">
                                        Personería Jurídica: Resolución 7786 del 15 de junio 1978
                                    </p>

                                </div>

                                <div className="col-12 md:col-3 mt-4 md:mt-0">
                                    <h4 className="font-medium text-white text-2xl line-height-3 mb-3 text-900">ENLACES DE INTERÉS</h4>
                                    <a className="line-height-3 text-white text-xl block cursor-pointer mb-2 text-700" href="https://cecar.edu.co/">Sitio web</a>
                                    <a className="line-height-3 text-white text-xl block cursor-pointer mb-2 text-700" href="https://sistema.cecar.edu.co/iceberg-pf/">Paga tus cuotas</a>
                                    <a className="line-height-3 text-white text-xl block cursor-pointer text-700" href="https://cecar.edu.co/pqrsf">PQRSF</a>
                                </div>

                                <div className="col-12 md:col-3 mt-4 md:mt-0">
                                    <h4 className="font-medium text-white text-2xl line-height-3 mb-3 text-900">REDES SOCIALES</h4>
                                    <a className="pi pi-facebook mr-3" style={{ fontSize: '2rem', color: 'white', fontWeight: 'bold' }} href='https://www.facebook.com/unicecar'></a>
                                    <a className="pi pi-instagram mr-3" style={{ fontSize: '2rem', color: 'white', fontWeight: 'bold' }} href='https://www.instagram.com/unicecar/'></a>
                                    <a className="pi pi-youtube mr-3" style={{ fontSize: '2rem', color: 'white', fontWeight: 'bold' }} href='https://www.youtube.com/unicecar'></a>

                                </div>

                                <div className="col-12 md:col-3 mt-4 md:mt-0">
                                    <h4 className="font-medium text-white text-2xl line-height-3 mb-3 text-900">CONTACTO</h4>
                                    <p className="pi pi-map-marker line-height-3 text-white text-xl block cursor-pointer mb-2 text-700">
                                        Sede principal: Carretera Troncal de Occidente Km. 1, Vía Corozal - Sincelejo, Colombia.
                                    </p>

                                    <p className="pi pi-whatsapp line-height-3 text-white text-xl block cursor-pointer mb-2 text-700">
                                        WhatsApp: 3145248816 – 3167410103
                                    </p>

                                    <p className="pi pi-envelope line-height-3 text-white text-xl block cursor-pointer mb-2 text-700">
                                        Correo archivocentral@cecar.edu.co
                                    </p>

                                    <p className="pi  pi-envelope line-height-3 text-white text-xl block cursor-pointer mb-2 text-700 pi pi-check">
                                        Si requieres soporte técnico, puedes contactar a credito@cecar.edu.co
                                    </p>
                                </div>

                            </div>


                        </div>
                        <div className="col-12">
                            Todos los derechos reservados ©2026 - Corporación Universitaria del Caribe - Powered by TicSoft
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </>
    );
};

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default BlocksGuestLandingPageCredito;